import React, { useEffect, useRef } from 'react';
// import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import '../../../../assets/css/Cogen.css';
import prof from '../../../../assets/images/prof.svg';
import { useNavigate } from 'react-router-dom';
import { Multiselect } from 'multiselect-react-dropdown';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import { useSelector } from 'react-redux';
import { Header } from '../../../Container';
function toDataURL(url) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.onload = function () {
			const reader = new FileReader();
			reader.onloadend = function () {
				resolve(reader.result);
			};
			reader.readAsDataURL(xhr.response);
		};
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.send();
	});
}
// window.html2canvas= html2canvas;
// window.jsPDF=window.jspdf.jsPDF;
// export function generatePDF(id,first_name){
//     html2canvas(document.querySelector("#element-to-print")).then(canvas =>{
//         let base64image = canvas.toDataURL('image/png');
//         let pdf = new jsPDF("p", "pt", "a4");
//         pdf.getFontSize(33);
//         pdf.setFont('Arial')
//         pdf.addImage(base64image, 'PNG', 25, 30, 540, 540);
//         pdf.save(`${id}-${first_name}`);
//     });
// }

// export function generatePDF() {
//     var doc = new jsPDF("p", "pt", "a4");
//     const d1 = doc.html(document.querySelector("#element-to-print"), {
//         callback: function (pdf) {
//             pdf.save("mypdf.pdf");
//         }

//     })
// }
export function generatePDF(id, first_name) {
	var element = document.getElementById('element-to-print');
	//    html2pdf().set({filename: js.AutoCode()+ '.pdf'}).from(element).save();
	var opt = {
		margin: 0.5,
		image: { type: 'png', quality: '0.98' },
		html2canvas: { scale: 2 },
		jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
	};

	let pdf = html2pdf().set(opt).from(element);
	pdf.save(`${id}-${first_name}`);
}

function ViewProfile(props) {
	let navigate = useNavigate();
	const [image, setImage] = React.useState(null);
	const ref = useRef();
	const location = useLocation();
	const { applicantList } = location.state;
	console.log(applicantList,"helopakistan")
	const profile = useSelector(slice => slice.auth.profile.user);
	console.log(profile);
	useEffect(() => {
		console.log('Top');
		if (profile.profile_image === null) {
			return;
		}
		(async function () {
			console.log('middle');

			const data = await toDataURL(profile.profile_image);
			setImage(data);
			console.log(data);
		})();
		console.log('Bottom');
	}, [profile]);
	console.log(profile, 'profile');
	return (
		<div>
			<Header type='client' />
			<Container
				fluid='md'
				className='mt-3 rounded shadow-sm p-3 mb-5 bg-white'
			>
				<Row>
					<Col>
						<div className='mt-2 mb-3 recruiter_actions' />
						<div className={'top-actions'}>
							<h4 className={'heading text-orange'}>Profile</h4>
						</div>
					</Col>
					<Col md='auto'>
						<Button
							className='btn_cancel'
							variant='primary'
							onClick={() => navigate('/')}
						>
							Back{' '}
						</Button>
					</Col>
				</Row>
				<div id='element-to-print'>
					<Row className='mt-5'>
						<Col md='auto'>
							<img
								className='profile'
								style={{ padding: '2px' }}
								src={applicantList.profile_image ? applicantList?.profile_image : prof}
								alt='profile'
							/>
						</Col>
						<Col md='auto' className='pl-3 pt-2'>
							{applicantList.fullname !== null && (
								<span className='text-primary'>
									{' '}
									{applicantList.fullname.name}{' '}
								</span>
							)}
							<br />
							{applicantList.fullname && applicantList.fullname && (
								<span>
									<strong>
										{applicantList.fullname}{' '}
									</strong>{' '}
								</span>
							)}
						</Col>
					</Row>
					<Row className='bg-label mt-4'>
						<Col className='fw-bold p-1 ml-3'> Applicant Info </Col>
					</Row>
					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<li className='list-group-item font-weight-normal'>
									Member ID:{' '}
									<span className='text-primary' id='profileID'>
										{applicantList.id}
									</span>
								</li>
							</ul>
						</Col>
					</Row>

					<Row className='bg-label mt-1'>
						<Col className='fw-bold p-1 ml-3'> Tags </Col>
					</Row>
					<Row>
						<Col>
							<ul className='list-group list-group-flush list-multi-select'>
								<Multiselect
									options={applicantList.tags}
									placeholder=''
									// isObject={false}
									displayValue='display_name'
									selectedValues={applicantList.tags}
									disable='true'
									style={{
										chips: {
											background: 'blue',
											fontWeight: '600',
											fontSize: '14px',
										},
										searchBox: { border: 'hidden', background: 'white' },
									}}
									// style={{ chips: {  color:"black", background:"white",fontWeight: "800",fontSize: "14px"}, searchBox: { border: "hidden" } }}
								/>
							</ul>
						</Col>
					</Row>
					<Row className='bg-label mt-1'>
						<Col className='fw-bold p-1 ml-3'> Member Information </Col>
					</Row>
					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Email:</span> {applicantList?.email}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Email-2:</span> {applicantList?.email2}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Phone: </span> {applicantList?.phone}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Phone-2: </span> {applicantList?.phone2}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Address:</span> {applicantList.address}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Job Location:</span>{' '}
									{applicantList.job_location == 'remote' && 'Remote'}{' '}
									{applicantList.job_location == 'both' && 'Both'}{' '}
									{applicantList.job_location == 'onsite' && 'On-Site'}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Job Preference:</span>{' '}
									{applicantList.job_preference}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Job Type: </span>{' '}
									{applicantList.job_type == 'fullTime' && 'Full Time'}{' '}
									{applicantList.job_type == 'halfTime' && 'Part-Time'}{' '}
									{applicantList.job_type == 'both' && 'Full Time & Part-Time'}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Travel Type:</span>{' '}
									{applicantList.travel_type == 'InState' && 'In-State'}{' '}
									{applicantList.travel_type == 'Domestic' && 'In-State and Domestic (US Only)'}{' '}
									{applicantList.travel_type == 'International' && 'International, Domestic, and In-State'}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Social Media Link: </span>{' '}
									{applicantList.linkedin_link}
									{applicantList.twit_link}
									{applicantList.facebook_link}
									{applicantList.fb_link}
									{applicantList.resume_link}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Worker Type: </span>{' '}
									{applicantList?.worker_type == '1099-subcontractor' &&
										'1099 Subcontractor'}
									{applicantList?.worker_type == 'w2-contingent-worker' &&
										'W-2 Contingent Worker'}
									{applicantList?.worker_type == 'contingent-to-full-time-employee' &&
										'W-2 Contingent to Direct Hire'}
									{applicantList?.worker_type == 'part-time-contingent' &&
										'Direct Hire Only'}
								</li>

								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Requirement: </span>
									{applicantList?.other_requirements?.map(
										(other_requirements, index) => {
											return (
												<span key={index}>
													{' '}
													{other_requirements}{' '}
													{applicantList?.other_requirements?.length != index + 1 && (
														<span>,</span>
													)}{' '}
												</span>
											);
										}
									)}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Expertise:</span>
									{applicantList?.specific_expertise?.map((expertise, index) => {
										return (
											<span key={index}>
												{' '}
												{expertise}
												{applicantList?.specific_expertise?.length != index + 1 && (
													<span>,</span>
												)}{' '}
											</span>
										);
									})}
								</li>
								<li className='list-group-item font-weight-normal'>
									{' '}
									<span className='fw-bold'>Tools: </span>
									{applicantList?.tool?.map((tool, index) => {
										return (
											<span key={index}>
												{' '}
												{tool}
												{applicantList?.tool?.length != index + 1 && (
													<span>,</span>
												)}{' '}
											</span>
										);
									})}
								</li>
							</ul>
						</Col>
					</Row>
					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<li className='list-group-item font-weight-normal'>
									{profile.official_doc}{' '}
								</li>
								<li className='list-group-item font-weight-normal'></li>
							</ul>
						</Col>
					</Row>
				</div>

				<div style={{ textAlign: 'center' }}>
					<button
						className='btn-save-profile'
						onClick={() => generatePDF(profile.id, profile.first_name)}
					>
						Download Profile
					</button>
				</div>
			</Container>
		</div>
	);
}

export default ViewProfile;
